export class SignatureSetsNginxConst {
  static getAllNames: () => string[] = () => {
    return [
      "All Response Signatures",
      "All Signatures",
      "Command Execution Signatures",
      "Cross Site Scripting Signatures",
      "Directory Indexing Signatures",
      "Generic Detection Signatures",
      "Generic Detection Signatures (High Accuracy)",
      "Generic Detection Signatures (High/Medium Accuracy)",
      "HTTP Response Splitting Signatures",
      "High Accuracy Detection Evasion Signatures",
      "High Accuracy Signatures",
      "Information Leakage Signatures",
      "Low Accuracy Signatures",
      "Medium Accuracy Signatures",
      "OS Command Injection Signatures",
      "OWA Signatures",
      "Other Application Attacks Signatures",
      "Path Traversal Signatures",
      "Predictable Resource Location Signatures",
      "Remote File Include Signatures",
      "SQL Injection Signatures",
      "Server Side Code Injection Signatures",
      "WebSphere signatures",
      "XPath Injection Signatures",
    ];
  };
}
